import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

import { chips as selectedFilterChips } from '@/common/components/SelectedFilters/constants'

import FilterCard from '../FilterCard/FilterCard'
import * as Styles from './styles'

const FilterRow = ({
  filter,
  showSeparator,
  isDeletable,
  availableFilterTypes,
  label,
  registerRef,
  sections,
  filterFields,
  fieldProps,
  onChangeType,
  onChangeValue,
  onDelete,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const icon = selectedFilterChips?.find(c => c.name === filter.type)?.Icon
  const chip = label && icon ? <Chip Icon={icon} label={t(label)} /> : null

  const handleType = newType => onChangeType(filter.id, newType)
  const handleValue = newValue => onChangeValue(filter.id, newValue)
  const handleDelete = () => onDelete(filter.id)

  return (
    <>
      {showSeparator && (
        <Styles.AndDivider>
          <Chip label={t('Y')} backgroundColor={theme.colors.success.surface} color={theme.colors.outline.default} />
        </Styles.AndDivider>
      )}
      <FilterCard
        ref={registerRef}
        type={filter.type}
        value={filter.value}
        onChangeType={handleType}
        onChangeValue={handleValue}
        onDelete={isDeletable && handleDelete}
        chipContent={chip}
        availableFilterTypes={availableFilterTypes}
        sections={sections}
        filterFields={filterFields}
        fieldProps={fieldProps}
      />
    </>
  )
}

export default FilterRow
